export default __webpack_public_path__ + "static/media/fb-icon.10fef2e9.svg";